import styles from './TabsRating.module.css';

function TabsRating({ activeTab, onTabChange }) {
  return (
    <div className={styles.tabs}>
      <button
        className={`${styles.tab} ${activeTab === 'members' ? styles.active : ''}`}
        onClick={() => onTabChange('members')}
      >
        Топ участников
      </button>
      <button
        className={`${styles.tab} ${activeTab === 'teams' ? styles.active : ''}`}
        onClick={() => onTabChange('teams')}
      >
        Топ команд
      </button>
    </div>
  );
}

export default TabsRating;
